import CheckIcon from 'assets/icons/check-circle-success.svg'
import ICThunderDisable from 'assets/icons/thunder-disable.svg'
import ICThunder from 'assets/icons/thunder-icon.svg'
import axios from 'axios'
import { P } from 'components'
import Camera from 'components/Camera/Camera'
import ComodityCardItem from 'components/CommodityCardItem'
import PMBTotalFooter from 'components/PMBTotalFooter'
import TermsAndConditionsConsent from 'components/TermsAndConditions'
import { useUploadRepoDocMutation } from 'features/private-views/commodity-repo/commodityRepoApiSlice'
import { useFetchSaldoQuery } from 'features/private-views/dashboard/dashboardApiSlice'
import { addBalance } from 'features/private-views/dashboard/dashboardSlice'
import { parseNumber } from 'helpers'
import moment from 'moment-timezone'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { ChevronDown, ChevronUp } from 'react-feather'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Card,
  CardBody,
  CardText,
  Col,
  Collapse,
  Container,
  FormGroup,
  Input,
  Row,
  Spinner,
} from 'reactstrap'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import { URL_CONFIRM_PIN_TRANSAKSI } from 'utils/pathUrl'
import { apiEndpoint } from '../../../utility/Utils'
import { setNumberStep, setTotal } from '../commodityPurchaseSlice'
import { getPricingDisbursment } from '../purchaseAction'
import ModalReceive from './ModalReceive'
import ModalTalanginConfirmation from './ModalTalanginConfirmation'
import './styles.css'

const ConfirmPayment = () => {
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const intl = useIntl()
  const location = useLocation()
  const dataState = location.state
  const setNumber = (e) => dispatch(setNumberStep(e))
  const { token } = useSelector((e) => e.auth)
  const { balance, individualUser } = useSelector((s) => s.dashboard)
  const { pricing, isLoading, total } = useSelector((s) => s.comodityPurchase)
  const [isInstant, setIsInstant] = useState(false)
  const [selectedPricing, setSelectedPricing] = useState(null)
  const [userData, setUserData] = useState({})
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [dataProfile, setDataProfile] = useState({})
  const [isOpenModalReceive, setIsOpenModalReceive] = useState(false)
  const [isShowConfirmSelfie, setIsShowConfirmSelfie] = useState(false)
  const { isSuccess, data, isError } = useFetchSaldoQuery()
  const [isShowCamera, setIsShowCamera] = useState(false)
  const [upload, { isLoading: uploadLoading }] = useUploadRepoDocMutation()
  const [selfieUrl, setSelfieUrl] = useState(null)
  const [isCollaps1, setIsCollaps1] = useState(true)
  const [isCollaps2, setIsCollaps2] = useState(false)
  const [isAgree, setIsAgree] = useState(false)
  const [isTNCOpen, setIsTNCOpen] = useState(false)

  const toggleModalReceive = () => {
    setIsOpenModalReceive(!isOpenModalReceive)
  }
  const toggleModal = () => {
    setIsOpenModal(!isOpenModal)
  }

  const handleSubmit = () => {
    navigate(URL_CONFIRM_PIN_TRANSAKSI, {
      state: {
        dataProfile: dataProfile,
        userData: userData,
        dataState: userData,
        selectedPricing: selectedPricing,
        selfieUrl: selfieUrl,
      },
    })
  }

  const getProfile = async () => {
    try {
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/profile`,
        { headers: { Authorization: `Bearer ${token}` } },
      )
      setDataProfile(data)
    } catch {
      // Error fetching profile
    }
  }

  const handleIsInstant = () => {
    setIsInstant(!isInstant)
    setSelectedPricing(null)
  }

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData'))
    const isInstant = JSON.parse(localStorage.getItem('PMB_isInstant'))
    if (isInstant && userData?.alreadyReceived) {
      setIsInstant(true)
      setSelectedPricing(isInstant)
    }
    setUserData(userData)
    setNumber(3)
    getProfile()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (userData?.alreadyReceived) {
      dispatch(
        getPricingDisbursment({
          sellerUserId: userData?.dataSeller?.userId,
          amount: userData?.finalTotalAmount,
        }),
      )
    }
    dispatch(
      setTotal(
        userData?.repo?.useAutorepo
          ? userData?.totalAmount +
              (userData?.feeTx?.haveFreeTx > 0 ? 0 : userData?.feeTx?.feeTx)
          : userData?.finalTotalAmount,
      ),
    )
  }, [userData])

  useEffect(() => {
    if (selectedPricing) {
      dispatch(
        setTotal(
          (userData?.repo?.useAutorepo
            ? userData?.totalAmount +
              (userData?.feeTx?.haveFreeTx > 0 ? 0 : userData?.feeTx?.feeTx)
            : userData?.finalTotalAmount) + selectedPricing?.fee,
        ),
      )
    } else {
      dispatch(
        setTotal(
          userData?.repo?.useAutorepo
            ? userData?.totalAmount +
                (userData?.feeTx?.haveFreeTx > 0 ? 0 : userData?.feeTx?.feeTx)
            : userData?.finalTotalAmount,
        ),
      )
    }
  }, [selectedPricing])

  useEffect(() => {
    if (isSuccess && data) {
      dispatch(addBalance(data))
    }
  }, [isSuccess, data])

  const onPayNow = () => {
    if (userData?.alreadyReceived) {
      if (localStorage?.getItem('PMB_modalReceived')) {
        handleSubmit()
      } else {
        toggleModalReceive()
      }
    } else {
      handleSubmit()
    }
  }

  const onSaveImage = async (data) => {
    try {
      const res = await upload(data).unwrap()
      setSelfieUrl(res)
      enqueueSnackbar('Selfie berhasil di upload', {
        variant: 'success',
      })
      setIsShowCamera(false)
      setIsShowConfirmSelfie(false)
      onPayNow()
    } catch (err) {
      enqueueSnackbar('Selfie gagal di upload', {
        variant: 'error',
      })
    }
  }

  const sumtotalPrice = userData?.dataComodities?.reduce(
    (total, item) => total + item.totalPrice,
    0,
  )

  const feeTransactionWithVat =
    userData?.feeTx?.haveFreeTx > 0
      ? (userData?.vat?.totalVAT ?? 0)
      : (userData?.feeTx?.feeTx ?? 0) + (userData?.vat?.totalVAT ?? 0)

  const totalUpFrontWithFeeTransaction =
    Number(userData?.selectedTenor?.upfront ?? 0) +
    Number(userData?.selectedTenor?.margin ?? 0) +
    (userData?.selectedTenor?.haveFreeTx
      ? 0
      : Number(userData?.selectedTenor?.feeTx ?? 0))

  const remainingFeeTransaction =
    sumtotalPrice +
    Number(userData?.selectedTenor?.margin ?? 0) +
    feeTransactionWithVat -
    Number(userData?.dataTenor?.creditRequested ?? 0)

  const isTalangin = userData?.useTalangin ?? false

  return (
    <div>
      <TermsAndConditionsConsent
        isOpen={isTNCOpen}
        handleClose={() => setIsTNCOpen(false)}
        titleTarget="transaksi-kredit-pasar-mikro"
      />
      <Camera
        onClose={() => {
          setIsShowCamera(false)
        }}
        onSaveImage={onSaveImage}
        isOpen={isShowCamera}
        loading={uploadLoading}
      />
      <ModalTalanginConfirmation
        isOpen={isShowConfirmSelfie}
        onClose={() => setIsShowConfirmSelfie(false)}
        onOpenCamera={() => setIsShowCamera(true)}
      />
      <ModalReceive
        toggle={toggleModalReceive}
        isOpen={isOpenModalReceive}
        handleSubmit={handleSubmit}
        testId="payment-receive-modal"
      />
      <Container fluid className="custom-container pb-5 mb-5">
        {/* INSTANT PAYMENT */}
        {userData?.alreadyReceived && (
          <Card body className="mb-3">
            <div className="d-flex justify-content-between">
              <CardText tag="h6" className="fw-bold">
                Pembayaran Instan
              </CardText>
              {isLoading ? (
                <Spinner color="primary" />
              ) : (
                <FormGroup switch>
                  <Input
                    type="switch"
                    role="switch"
                    onChange={handleIsInstant}
                    checked={isInstant}
                  />
                </FormGroup>
              )}
            </div>

            <Collapse isOpen={isInstant}>
              <div className="flex-centered justify-content-between gap-1">
                <div className="d-flex flex-column gap-3">
                  {pricing?.items
                    ?.filter((e) => !(e?.fee === 0 && !e?.originalFee))
                    ?.map((e, i) => {
                      return (
                        <div key={i}>
                          <Card
                            style={{
                              backgroundColor:
                                selectedPricing?.id === e?.id
                                  ? '#ECFAFF'
                                  : e?.disable
                                    ? '#F9FAFB'
                                    : '',
                            }}
                            className={`${
                              selectedPricing?.id === e?.id
                                ? 'border-primary'
                                : ''
                            }`}
                            onClick={() => {
                              if (!e?.disable) {
                                setSelectedPricing(e)
                              }
                            }}
                            data-testid={`payment-instant-pricing-${e?.id}`}
                          >
                            <CardBody className="pb-0">
                              <div className="d-flex justify-content-between">
                                <div className="d-flex flex-row gap-2">
                                  <div>
                                    <img
                                      src={
                                        e?.disable
                                          ? ICThunderDisable
                                          : ICThunder
                                      }
                                      alt="kilat"
                                      width={40}
                                      height={40}
                                    />
                                  </div>
                                  <div>
                                    <span style={{ fontWeight: '500' }}>
                                      Instan {e?.title}
                                      <span style={{ fontWeight: '500' }}>
                                        {e?.fee !== 0 && 'Instan'} (
                                        {e?.originalFee !== undefined &&
                                        e?.originalFee !== null &&
                                        e?.originalFee > e?.fee ? (
                                          <>
                                            <span
                                              style={{
                                                textDecoration: 'line-through',
                                                color: '#667085',
                                              }}
                                            >
                                              Rp
                                              {newFormatThousandSeparator(
                                                Number(e?.originalFee),
                                                0,
                                              )}
                                            </span>
                                            <span
                                              style={{
                                                marginLeft: '5px',
                                                fontWeight: 'bold',
                                                color: 'black',
                                              }}
                                            >
                                              Rp
                                              {newFormatThousandSeparator(
                                                Number(e?.fee),
                                                0,
                                              )}
                                            </span>
                                          </>
                                        ) : (
                                          <span>
                                            Rp
                                            {newFormatThousandSeparator(
                                              Number(e?.fee),
                                              0,
                                            )}
                                          </span>
                                        )}
                                        )
                                      </span>
                                    </span>
                                    <p
                                      style={{
                                        color:
                                          selectedPricing?.id === e?.id
                                            ? '#006386'
                                            : '',
                                      }}
                                    >
                                      {e?.disable ? (
                                        <span style={{ color: '#B42318' }}>
                                          {e?.disableReason}
                                        </span>
                                      ) : (
                                        <span>{e.description}</span>
                                      )}
                                    </p>
                                  </div>
                                </div>
                                <Input
                                  type="radio"
                                  disabled={e?.disable}
                                  checked={selectedPricing?.id === e?.id}
                                  onChange={() => {
                                    if (!e?.disable) {
                                      setSelectedPricing(e)
                                    }
                                  }}
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </div>
                      )
                    })}
                </div>
              </div>
            </Collapse>
          </Card>
        )}

        <Card className="border-0 shadow-sm" style={{ marginBottom: '16px' }}>
          <CardBody>
            <P size="medium" bold style={{ marginBottom: '14px' }}>
              Informasi Penjual
            </P>

            <Row className="mb-2">
              <Col xs="4" className="fw-light text-sm">
                <P>Penjual</P>
              </Col>
              <Col xs="8" className="fw-semibold text-sm">
                <P>
                  {userData?.dataSeller?.partnership?.name ??
                    userData?.dataSeller?.fullName ??
                    '-'}
                </P>
              </Col>
            </Row>

            {userData?.dataSeller?.phoneNumber && (
              <Row className="mb-2">
                <Col xs="4" className="fw-light text-sm">
                  <P>Telepon</P>
                </Col>
                <Col xs="8" className="fw-semibold text-sm">
                  <P>{userData?.dataSeller?.phoneNumber ?? '-'}</P>
                </Col>
              </Row>
            )}

            {userData?.dataSeller?.email && (
              <Row className="mb-2">
                <Col xs="4" className="fw-light text-sm">
                  <P>Email</P>
                </Col>
                <Col xs="8" className="fw-semibold text-sm">
                  <P>{userData?.dataSeller?.email ?? '-'}</P>
                </Col>
              </Row>
            )}
          </CardBody>
        </Card>

        {/* CARD COLLAPSIBLE 1 */}
        <Card className="border-0 shadow-sm" style={{ marginBottom: '16px' }}>
          <CardBody>
            <div className="mb-3 d-flex justify-content-between">
              <div>
                <P size="medium" bold>
                  {isTalangin
                    ? 'Daftar pembelian PasarMIKRO dari Penjual'
                    : 'Daftar pembelian'}
                </P>

                {userData?.alreadyReceived && (
                  <>
                    <div className="text-success-700 rounded bg-success-50 p-1">
                      <small className="fw-500 mx-1">
                        <img src={CheckIcon} alt="check-icon" /> Barang sudah
                        diterima
                      </small>
                    </div>
                  </>
                )}
              </div>
              {isCollaps1 ? (
                <ChevronUp
                  style={{ cursor: 'pointer' }}
                  onClick={() => setIsCollaps1((prev) => !prev)}
                  data-testid="payment-details-toggle-1"
                />
              ) : (
                <ChevronDown
                  style={{ cursor: 'pointer' }}
                  onClick={() => setIsCollaps1((prev) => !prev)}
                  data-testid="payment-details-toggle-1"
                />
              )}
            </div>

            {isCollaps1 && (
              <div className="card-open-style">
                {userData?.item?.map((e, index) => {
                  const unitPrice = e?.enableVAT
                    ? parseNumber(e?.priceAfterVAT ?? e?.price)
                    : parseNumber(e?.price)

                  const total =
                    unitPrice *
                    (typeof e?.amount === 'string'
                      ? parseNumber(e?.amount)
                      : e?.amount)

                  return (
                    <ComodityCardItem
                      key={index}
                      comodity={e?.comodity}
                      amount={e?.amount}
                      unit={e?.unit}
                      price={parseNumber(e?.price)}
                      total={total}
                    />
                  )
                })}
              </div>
            )}
            <hr />
            {isTalangin ? (
              <P bold>
                Total Nilai Kontrak Pembelian
                <strong className="float-end fw-semibold">
                  <P bold className={'text-primary'}>
                    Rp
                    {newFormatThousandSeparator(Number(sumtotalPrice ?? 0), 0)}
                  </P>
                </strong>
              </P>
            ) : (
              <>
                <P bold>
                  Total
                  <strong className="float-end fw-semibold">
                    <P bold className={'text-primary'}>
                      Rp
                      {newFormatThousandSeparator(
                        Number(sumtotalPrice ?? 0),
                        0,
                      )}
                    </P>
                  </strong>
                </P>
                <P bold>
                  Biaya transaksi (termasuk PPN)
                  <strong className="float-end fw-semibold">
                    <P className="text-primary" bold>
                      Rp
                      {newFormatThousandSeparator(feeTransactionWithVat, 0)}
                    </P>
                  </strong>
                </P>
              </>
            )}
          </CardBody>
        </Card>

        {/* CARD COLLAPSIBLE 2 */}
        {isTalangin && (
          <Card className="border-0 shadow-sm" style={{ marginBottom: '16px' }}>
            <CardBody>
              <div className="mb-3 d-flex justify-content-between">
                <P size="medium" bold>
                  Daftar pembelian Pembeli dari PasarMIKRO
                </P>
                {isCollaps2 ? (
                  <ChevronUp
                    style={{ cursor: 'pointer' }}
                    onClick={() => setIsCollaps2((prev) => !prev)}
                    data-testid="payment-details-toggle-2"
                  />
                ) : (
                  <ChevronDown
                    style={{ cursor: 'pointer' }}
                    onClick={() => setIsCollaps2((prev) => !prev)}
                    data-testid="payment-details-toggle-2"
                  />
                )}
              </div>

              {/* TEMPORARY: DONT REMOVE CODE BELOW */}
              {/* {isCollaps2 && (
              <div className="card-open-style">
                {userData?.item?.map((e, index) => {
                  const baseTotal = userData.dataComodities.reduce(
                    (sum, item) => sum + Number(item.totalPrice),
                    0,
                  )

                  const commodity = userData.dataComodities.find(
                    (item) => item?.comodity?.id === e?.comodity?.id,
                  )
                  const itemBasePrice = Number(commodity?.totalPrice ?? 0)
                  const itemRatio = itemBasePrice / baseTotal

                  const adjustedTotalPrice = Math.round(
                    itemRatio * Number(userData?.selectedTenor?.total ?? 0),
                  )

                  const adjustedUnitPrice =
                    adjustedTotalPrice / Number(e?.amount)

                  return (
                    <ComodityCardItem
                      key={index}
                      comodity={e?.comodity}
                      amount={Number(e?.amount)}
                      unit={e?.unit}
                      price={adjustedUnitPrice}
                      total={adjustedTotalPrice}
                    />
                  )
                })}
              </div>
            )} */}

              {isCollaps2 && (
                <div className="card-open-style">
                  {(() => {
                    const baseTotal = userData.dataComodities.reduce(
                      (sum, item) => sum + Number(item.totalPrice),
                      0,
                    )

                    let accumulatedTotal = 0

                    return userData?.item?.map((e, index) => {
                      const commodity = userData.dataComodities.find(
                        (item) => item?.comodity?.id === e?.comodity?.id,
                      )
                      const itemBasePrice = Number(commodity?.totalPrice ?? 0)
                      const itemRatio = itemBasePrice / baseTotal

                      let displayUnitPrice, displayTotal

                      if (index < userData.item.length - 1) {
                        const idealTotal = Math.round(
                          itemRatio *
                            Number(userData?.selectedTenor?.total ?? 0),
                        )
                        displayUnitPrice = Math.round(
                          idealTotal / Number(e?.amount),
                        )
                        displayTotal = displayUnitPrice * Number(e?.amount)
                      } else {
                        const remainingTotal =
                          Number(userData?.totalAmount ?? 0) - accumulatedTotal
                        displayUnitPrice = Math.floor(
                          remainingTotal / Number(e?.amount),
                        )
                        displayTotal = displayUnitPrice * Number(e?.amount)

                        const diff = remainingTotal - displayTotal
                        displayTotal += diff
                      }
                      accumulatedTotal += displayTotal

                      return (
                        <ComodityCardItem
                          key={index}
                          comodity={e?.comodity}
                          amount={Number(e?.amount)}
                          unit={e?.unit}
                          price={displayUnitPrice}
                          total={displayTotal}
                        />
                      )
                    })
                  })()}
                </div>
              )}
              <hr />
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <P bold>Total Nilai Kontrak Penjualan</P>
                  <P
                    size="small"
                    className="text-muted"
                    style={{ fontStyle: 'italic' }}
                  >
                    Harga satuan ditampilkan dalam bilangan bulat.
                    <br />
                    Total akhir telah disesuaikan untuk menjamin akurasi nilai
                    kontrak.
                  </P>
                </div>
                <strong className="float-end fw-semibold">
                  <P bold className={'text-primary'}>
                    Rp
                    {newFormatThousandSeparator(
                      Number(userData?.totalAmount ?? 0),
                      0,
                    )}
                  </P>
                </strong>
              </div>
            </CardBody>
          </Card>
        )}

        {isTalangin && (
          <Card className="border-0 shadow-sm" style={{ marginBottom: '32px' }}>
            <CardBody>
              <P size="medium" bold style={{ marginBottom: '14px' }}>
                Ringkasan Pembelian
              </P>

              <div className="mb-4">
                <div className="d-flex justify-content-between mb-2">
                  <P>Biaya transaksi (termasuk PPN)</P>
                  <div className="d-flex justify-content-around gap-2">
                    {/* {userData?.feeTx?.haveFreeTx > 0 && (
                    <P className="text-secondary text-decoration-line-through">
                      Rp
                      {newFormatThousandSeparator(
                        (userData?.feeTx?.feeTx ?? 0) +
                          (userData?.vat?.totalVAT ?? 0),
                        0,
                      )}
                    </P>
                  )} */}
                    <P className="text-primary" bold>
                      Rp
                      {newFormatThousandSeparator(feeTransactionWithVat, 0)}
                    </P>
                  </div>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <P>Uang muka termasuk biaya transaksi</P>
                  <P className="text-primary" bold>
                    Rp
                    {newFormatThousandSeparator(
                      totalUpFrontWithFeeTransaction,
                      0,
                    )}
                  </P>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <P>Sisa Pembayaran Kontrak Penjualan</P>
                  <P className="text-primary" bold>
                    Rp
                    {newFormatThousandSeparator(
                      Number(userData?.dataTenor?.creditRequested ?? 0),
                      0,
                    )}
                  </P>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <P>Denda keterlambatan pembayaran</P>
                  <P className="text-primary" bold>
                    {userData?.dataTenor?.dailyFinePercentage ?? 0}% per hari
                  </P>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <P>Tanggal Pembayaran Uang Muka</P>
                  <P className="text-primary" bold>
                    {moment().format('Do MMM YYYY')}
                  </P>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <P>Tanggal Jatuh Tempo</P>
                  <P className="text-primary" bold>
                    {moment(
                      userData?.selectedTenor?.dueDate ||
                        userData?.selectedTenor?.duedate,
                    ).format('Do MMM YYYY')}
                  </P>
                </div>
              </div>

              <P bold size="medium">
                Pembeli menyetujui ketentuan-ketentuan berikut:
              </P>
              <div className="mb-5">
                <ul>
                  <li>
                    Pembeli setuju untuk membayar uang muka kepada PasarMIKRO
                    pada tanggal {moment().format('Do MMM YYYY')} melalui
                    Aplikasi.
                  </li>
                  <li>
                    Pembeli setuju untuk membayar sisa Pembayaran Kontrak
                    Penjualan kepada PasarMIKRO pada atau sebelum tanggal{' '}
                    {moment(userData?.selectedTenor?.duedate).format(
                      'Do MMM YYYY',
                    )}{' '}
                    melalui Aplikasi.
                  </li>
                  <li>
                    Jika Pembeli tidak dapat melakukan pembayaran melalui
                    Aplikasi, Pembeli harus mentransfer pembayaran ke rekening
                    Bank Central Asia (BCA) nomor rekening 7660857766 atas nama
                    PT Pasar Mikro Global.
                  </li>
                </ul>
              </div>

              <div className="d-flex align-items-center gap-2">
                <Input
                  type="checkbox"
                  onChange={(e) => setIsAgree(e.target.checked)}
                  checked={isAgree}
                  data-testid="payment-agreement-checkbox"
                />
                <P className="fw-semibold">
                  Saya setuju untuk membeli Barang dari Pasar Mikro sesuai
                  dengan ketentuan yang tercantum dalam{' '}
                  <span
                    className="text-primary hover-underline"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setIsTNCOpen(true)}
                    data-testid="payment-tnc-link"
                  >
                    {' '}
                    Pasal 5.1
                  </span>{' '}
                  dari Syarat & Ketentuan dan konfirmasi di atas.
                </P>
              </div>
            </CardBody>
          </Card>
        )}
      </Container>

      <PMBTotalFooter
        total={total}
        isDisable={
          // total < 50000 ||
          (isTalangin && !isAgree) ||
          (userData?.paymentMethod < 2 &&
            (userData?.repo?.useAutorepo
              ? userData?.totalAmount +
                (userData?.feeTx?.haveFreeTx > 0 ? 0 : userData?.feeTx?.feeTx)
              : userData?.finalTotalAmount) +
              (selectedPricing?.fee ?? 0) -
              (userData?.useTalangin ? userData?.maxCreditLimit : 0) >
              balance?.uangBelanja)
        }
        onSubmit={() => {
          if (individualUser && userData?.useTalangin) {
            setIsShowConfirmSelfie(true)
          } else {
            onPayNow()
          }
        }}
        text="Bayar Sekarang"
        testId="payment"
      />
    </div>
  )
}

export default ConfirmPayment
